import { Outlet } from 'react-router-dom';

import { InstancesProvider } from './index';

export const InstanceProviderWithOutlet = () => (
  <InstancesProvider>
    <Outlet />
  </InstancesProvider>
);
